import React from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import CardHeader from '../../../../shared/components/card-header/CardHeader';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import HeaderSearchRefreshFilterOptions from '../../../../shared/components/HeaderSearchRefreshFilterOptions';
import CardSection from '../../../../shared/components/CardSection';
import InputDate from '../../../../shared/components/InputDate';
import CardBody from '../../../../shared/components/CardBody';
import { PsTable } from '../../../../shared/components/table/PsTable';
import { ButtonIcon } from '../../../../shared/components/ButtonIcon';
import Row from '../../../../shared/components/Row';
import Button from '../../../../shared/components/Button';
import Card from '../../../../shared/components/Card';
import { PsDate } from '../../../../shared/model/PsDate';

const initialState = {
    importedPresences: [],
    importedPresencesDate: PsDate.fromNow(),
    importedPresencesLoading: false,
};

export class PresenceSelectedWorkers extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            ...initialState,
        };
    }

    render() {
        const {
            loading,
            presences,
            selectDate,
            presencesDate,
            savePresences,
        } = this.props;

        return (
            <React.Fragment>
                <Card
                    className={'worker-card'}
                    loading={loading}
                >
                    <CardHeader
                        title={I18nUtils.tr('TR_PRESENCIA_DIARIA')}
                        rightOptions={
                            <HeaderSearchRefreshFilterOptions
                                enableSearch={false}
                                enableFilter={false}
                                enableRefresh={false}
                                moreOptions={this.moreOptions()}
                            />
                        }
                    />
                    <CardSection>
                        <InputDate
                            col={'col-lg-3 col-md-3 col-sm-3 col-xs-3'}
                            label={I18nUtils.tr('TR_FECHA')}
                            value={presencesDate.toDateString()}
                            onChange={selectDate}
                            className={'form-input-date-container'}
                        />
                    </CardSection>
                    <CardBody className={'component-worker-card-daily-presence'}>
                        <PsTable headings={this.renderHead()}>
                            {
                                presences && presences.length > 0 ?
                                    presences.map(presence => {
                                        return (
                                            <tr key={presence.id()}>
                                                <td>{presence.workerCompleteName()}</td>
                                                <td>{presence.workerCompanyName()}</td>
                                                <td>
                                                    <ButtonIcon
                                                        icon={'remove'}
                                                        onClick={() => this.removePresence(presence)}
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    }) : (
                                        <h4 className={'text-center'}>
                                            {I18nUtils.tr('TR_NO_HAY_PRESENCIAS')}
                                        </h4>
                                    )
                            }
                        </PsTable>
                        <Row>
                            <Col mdOffset={6} md={6}>
                                <Button
                                    text={I18nUtils.tr('TR_GUARDAR_PRESENCIAS')}
                                    className="btn-lg btn-block btn-primary waves-effect form-btn"
                                    onClick={savePresences}
                                />
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </React.Fragment>
        );
    }

    renderHead() {
        const { presences } = this.props;

        if ( !presences || presences.length === 0 ) {
            return null;
        }
        return (
            <tr>
                <th>{I18nUtils.tr('TR_NOMBRE')}</th>
                <th>{I18nUtils.tr('TR_SUBCONTRATA')}</th>
                <th/>
            </tr>
        );
    }

    moreOptions() {
        const { presences } = this.props;

        return [
            {
                id: 'remove-all',
                title: I18nUtils.tr('TR_ELIMINAR_TODOS'),
                active: false,
                disabled: presences.length === 0,
                onClick: () => this.removeAllPresences(),
            },
        ];
    }

    removePresence = (presence) => {
        const { presences } = this.props;
        const nextPresences = presences.filter(p => !p.equals(presence));
        this.props.selectPresences(nextPresences);
    };

    removeAllPresences = () => {
        this.props.selectPresences([]);
    };
}

PresenceSelectedWorkers.propTypes = {
    workId: PropTypes.number.isRequired,
    loading: PropTypes.bool.isRequired,
    presences: PropTypes.array.isRequired,
    importDay: PropTypes.func.isRequired,
    selectDate: PropTypes.any.isRequired,
    savePresences: PropTypes.func.isRequired,
    presencesDate: PropTypes.any.isRequired,
    selectPresences: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/app/my-outsources/presence/management/add/PresenceSelectedWorkers.jsx